// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file integrations/v1/integration.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ConnectorType, ConnectorTypeJson } from "./connector_pb";
import { file_integrations_v1_connector } from "./connector_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations/v1/integration.proto.
 */
export const file_integrations_v1_integration: GenFile =
	/*@__PURE__*/
	fileDesc(
		"CiFpbnRlZ3JhdGlvbnMvdjEvaW50ZWdyYXRpb24ucHJvdG8SD2ludGVncmF0aW9ucy52MSKoAQoKQ29ubmVjdGlvbhIKCgJpZBgBIAEoCRIOCgZvcmdfaWQYAiABKAkSFAoMd29ya3NwYWNlX2lkGAMgASgJEhYKDmludGVncmF0aW9uX2lkGAQgASgJEhgKEGludGVncmF0aW9uX25hbWUYBSABKAkSNgoOY29ubmVjdG9yX3R5cGUYBiABKA4yHi5pbnRlZ3JhdGlvbnMudjEuQ29ubmVjdG9yVHlwZSJwCg9Xb3Jrc3BhY2VUZW5hbnQSCgoCaWQYASABKAkSEwoLZXh0ZXJuYWxfaWQYAiABKAkSDgoGb3JnX2lkGAMgASgJEhQKDHdvcmtzcGFjZV9pZBgEIAEoCRIWCg5pbnRlZ3JhdGlvbl9pZBgFIAEoCSL7AQoLSW50ZWdyYXRpb24SCgoCaWQYASABKAkSEwoLZXh0ZXJuYWxfaWQYAiABKAkSCwoDa2V5GAMgASgJEhQKDGRpc3BsYXlfbmFtZRgEIAEoCRI2CghjYXRlZ29yeRgFIAEoDjIkLmludGVncmF0aW9ucy52MS5JbnRlZ3JhdGlvbkNhdGVnb3J5EhYKDmNvbm5lY3Rvcl9uYW1lGAYgASgJEi4KBHR5cGUYByABKA4yIC5pbnRlZ3JhdGlvbnMudjEuSW50ZWdyYXRpb25UeXBlEhYKDm1hbmFnZW1lbnRfdXJsGAggASgJEhAKCGxvZ29fdXJsGAkgASgJInQKC01hcmtldHBsYWNlEjIKDGludGVncmF0aW9ucxgBIAMoCzIcLmludGVncmF0aW9ucy52MS5JbnRlZ3JhdGlvbhIxCgd0ZW5hbnRzGAIgAygLMiAuaW50ZWdyYXRpb25zLnYxLldvcmtzcGFjZVRlbmFudCp5ChNJbnRlZ3JhdGlvbkNhdGVnb3J5EiQKIElOVEVHUkFUSU9OX0NBVEVHT1JZX1VOU1BFQ0lGSUVEEAASHAoYSU5URUdSQVRJT05fQ0FURUdPUllfQ1JNEAESHgoaSU5URUdSQVRJT05fQ0FURUdPUllfQUdFTlQQAippCg9JbnRlZ3JhdGlvblR5cGUSIAocSU5URUdSQVRJT05fVFlQRV9VTlNQRUNJRklFRBAAEhgKFElOVEVHUkFUSU9OX1RZUEVfRVRMEAESGgoWSU5URUdSQVRJT05fVFlQRV9QUk9YWRACYgZwcm90bzM",
		[file_integrations_v1_connector],
	);

/**
 * Connection represents a workspace connected to an integration
 *
 * @generated from message integrations.v1.Connection
 */
export type Connection = Message<"integrations.v1.Connection"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string integration_id = 4;
	 */
	integrationId: string;

	/**
	 * @generated from field: string integration_name = 5;
	 */
	integrationName: string;

	/**
	 * @generated from field: integrations.v1.ConnectorType connector_type = 6;
	 */
	connectorType: ConnectorType;
};

/**
 * Connection represents a workspace connected to an integration
 *
 * @generated from message integrations.v1.Connection
 */
export type ConnectionJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string integration_id = 4;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string integration_name = 5;
	 */
	integrationName?: string;

	/**
	 * @generated from field: integrations.v1.ConnectorType connector_type = 6;
	 */
	connectorType?: ConnectorTypeJson;
};

/**
 * Describes the message integrations.v1.Connection.
 * Use `create(ConnectionSchema)` to create a new message.
 */
export const ConnectionSchema: GenMessage<Connection, { jsonType: ConnectionJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_integration, 0);

/**
 * Represents an installation of a proxy integration
 *
 * @generated from message integrations.v1.WorkspaceTenant
 */
export type WorkspaceTenant = Message<"integrations.v1.WorkspaceTenant"> & {
	/**
	 * id of the proxy integration install
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * reference installation id from provider platform
	 *
	 * @generated from field: string external_id = 2;
	 */
	externalId: string;

	/**
	 * org id where the integration was installed
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * workspace id where the integration was installed
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * id of the proxy integration
	 *
	 * @generated from field: string integration_id = 5;
	 */
	integrationId: string;
};

/**
 * Represents an installation of a proxy integration
 *
 * @generated from message integrations.v1.WorkspaceTenant
 */
export type WorkspaceTenantJson = {
	/**
	 * id of the proxy integration install
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * reference installation id from provider platform
	 *
	 * @generated from field: string external_id = 2;
	 */
	externalId?: string;

	/**
	 * org id where the integration was installed
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * workspace id where the integration was installed
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * id of the proxy integration
	 *
	 * @generated from field: string integration_id = 5;
	 */
	integrationId?: string;
};

/**
 * Describes the message integrations.v1.WorkspaceTenant.
 * Use `create(WorkspaceTenantSchema)` to create a new message.
 */
export const WorkspaceTenantSchema: GenMessage<WorkspaceTenant, { jsonType: WorkspaceTenantJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_integration, 1);

/**
 * @generated from message integrations.v1.Integration
 */
export type Integration = Message<"integrations.v1.Integration"> & {
	/**
	 * id of the integration
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * reference integration id from provider platform
	 *
	 * @generated from field: string external_id = 2;
	 */
	externalId: string;

	/**
	 * unique key identifier for the integration
	 *
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * display name for the integration
	 *
	 * @generated from field: string display_name = 4;
	 */
	displayName: string;

	/**
	 * the category for the integration
	 *
	 * @generated from field: integrations.v1.IntegrationCategory category = 5;
	 */
	category: IntegrationCategory;

	/**
	 * the name of the external system
	 *
	 * @generated from field: string connector_name = 6;
	 */
	connectorName: string;

	/**
	 * the integration type
	 *
	 * @generated from field: integrations.v1.IntegrationType type = 7;
	 */
	type: IntegrationType;

	/**
	 * the url to show the auth dialog for the provider to install the integration
	 *
	 * @generated from field: string management_url = 8;
	 */
	managementUrl: string;

	/**
	 * url to the logo for the integration
	 *
	 * @generated from field: string logo_url = 9;
	 */
	logoUrl: string;
};

/**
 * @generated from message integrations.v1.Integration
 */
export type IntegrationJson = {
	/**
	 * id of the integration
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * reference integration id from provider platform
	 *
	 * @generated from field: string external_id = 2;
	 */
	externalId?: string;

	/**
	 * unique key identifier for the integration
	 *
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * display name for the integration
	 *
	 * @generated from field: string display_name = 4;
	 */
	displayName?: string;

	/**
	 * the category for the integration
	 *
	 * @generated from field: integrations.v1.IntegrationCategory category = 5;
	 */
	category?: IntegrationCategoryJson;

	/**
	 * the name of the external system
	 *
	 * @generated from field: string connector_name = 6;
	 */
	connectorName?: string;

	/**
	 * the integration type
	 *
	 * @generated from field: integrations.v1.IntegrationType type = 7;
	 */
	type?: IntegrationTypeJson;

	/**
	 * the url to show the auth dialog for the provider to install the integration
	 *
	 * @generated from field: string management_url = 8;
	 */
	managementUrl?: string;

	/**
	 * url to the logo for the integration
	 *
	 * @generated from field: string logo_url = 9;
	 */
	logoUrl?: string;
};

/**
 * Describes the message integrations.v1.Integration.
 * Use `create(IntegrationSchema)` to create a new message.
 */
export const IntegrationSchema: GenMessage<Integration, { jsonType: IntegrationJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_integration, 2);

/**
 * @generated from message integrations.v1.Marketplace
 */
export type Marketplace = Message<"integrations.v1.Marketplace"> & {
	/**
	 * @generated from field: repeated integrations.v1.Integration integrations = 1;
	 */
	integrations: Integration[];

	/**
	 * @generated from field: repeated integrations.v1.WorkspaceTenant tenants = 2;
	 */
	tenants: WorkspaceTenant[];
};

/**
 * @generated from message integrations.v1.Marketplace
 */
export type MarketplaceJson = {
	/**
	 * @generated from field: repeated integrations.v1.Integration integrations = 1;
	 */
	integrations?: IntegrationJson[];

	/**
	 * @generated from field: repeated integrations.v1.WorkspaceTenant tenants = 2;
	 */
	tenants?: WorkspaceTenantJson[];
};

/**
 * Describes the message integrations.v1.Marketplace.
 * Use `create(MarketplaceSchema)` to create a new message.
 */
export const MarketplaceSchema: GenMessage<Marketplace, { jsonType: MarketplaceJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_integration, 3);

/**
 * @generated from enum integrations.v1.IntegrationCategory
 */
export enum IntegrationCategory {
	/**
	 * @generated from enum value: INTEGRATION_CATEGORY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INTEGRATION_CATEGORY_CRM = 1;
	 */
	CRM = 1,

	/**
	 * @generated from enum value: INTEGRATION_CATEGORY_AGENT = 2;
	 */
	AGENT = 2,
}

/**
 * @generated from enum integrations.v1.IntegrationCategory
 */
export type IntegrationCategoryJson = "INTEGRATION_CATEGORY_UNSPECIFIED" | "INTEGRATION_CATEGORY_CRM" | "INTEGRATION_CATEGORY_AGENT";

/**
 * Describes the enum integrations.v1.IntegrationCategory.
 */
export const IntegrationCategorySchema: GenEnum<IntegrationCategory, IntegrationCategoryJson> = /*@__PURE__*/ enumDesc(file_integrations_v1_integration, 0);

/**
 * @generated from enum integrations.v1.IntegrationType
 */
export enum IntegrationType {
	/**
	 * @generated from enum value: INTEGRATION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INTEGRATION_TYPE_ETL = 1;
	 */
	ETL = 1,

	/**
	 * @generated from enum value: INTEGRATION_TYPE_PROXY = 2;
	 */
	PROXY = 2,
}

/**
 * @generated from enum integrations.v1.IntegrationType
 */
export type IntegrationTypeJson = "INTEGRATION_TYPE_UNSPECIFIED" | "INTEGRATION_TYPE_ETL" | "INTEGRATION_TYPE_PROXY";

/**
 * Describes the enum integrations.v1.IntegrationType.
 */
export const IntegrationTypeSchema: GenEnum<IntegrationType, IntegrationTypeJson> = /*@__PURE__*/ enumDesc(file_integrations_v1_integration, 1);
